import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=1ed20404&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed20404",
  null
  
)

export default component.exports